export default "__VITE_ASSET__D5G7GFn7__"